import React, { useEffect, useState } from 'react';
import "./Login.css"
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import {Token, post} from "../../Script/Session.js";
import { useNavigate } from 'react-router-dom';
import {deleteCookie, getCookie, cookieExists} from "../../Script/cookies.js";
import { setloginvalue } from '../../Script/variables.js';
export let val = "";
const Login = () => {
    const navigate = useNavigate();
    const [aftercontentemail, setAfterContentemail] = useState(false);
    const [afterContentpw, setAfterContentpw] = useState("");

    let elligalchars = false;
    const [buttonText, setButtonText] = useState('Anmelden');


    const changeinputtext = () => {
      setAfterContentemail(false);
      let us = document.getElementById("username");
      let pw = document.getElementById("password");

      if (us.value.includes(">")||us.value.includes("<") || us.value.includes('"') || us.value.includes("'") || us.value.includes(" ") || us.value.includes(":")){
        elligalchars = true
        us.style.borderColor =  "#ff0000";

      }else {
        elligalchars = false
        us.style.borderColor =  "#ccc";
      }
      if (pw.value.includes(">") ||pw.value.includes("<") || pw.value.includes('"') || pw.value.includes("'")  ||pw.value.includes(":")){
        elligalchars = true
        pw.style.borderColor = "#ff0000";
      }else {
        elligalchars = false;
        pw.style.borderColor = "#ccc";
      }
      

    };
    useEffect(() => {
      try {
        let body = {}
        if (cookieExists("balk.intranet.value")){
           let value = getCookie("balk.intranet.value");
           let code = getCookie("balk.intranetcode");
           body.value = value;
           body.code = code;
           let response = post(body,"/rememberlogin");
           if (response != null) {
            let t = JSON.parse(response).token;
            Token.set(t);

            navigate("/home");
           }else {
            deleteCookie("balk.intranet.value");
            deleteCookie("balk.intranetcode");
           }
        }
      }catch(e) {
        console.log(e);
      
      }
    });




    const login = (event) =>{
      event.preventDefault();
      if (elligalchars) {
        document.getElementById("username").blur();
        document.getElementById("password").blur();
        return;
      }
      let us = document.getElementById("username").value;
      let pw = document.getElementById("password").value;
      if (!us || !pw) {
        setAfterContentemail(true);
        return;
      }
      let body = {};
      let s = us + ":" + pw;
      body.value = btoa(s);
      body.method ="normal";
      let response = post(body,"/login");
      if (response == null) {
        document.getElementById("username").style.borderColor =  "#ff0000";
        document.getElementById("password").style.borderColor =  "#ff0000";
        setAfterContentemail(true);

        return;
      }
      let t = JSON.parse(response).token;
      
      if (t === "-1"){
         setloginvalue(btoa(s));
         navigate("/2auth");
      }else {
        Token.set(t);
        navigate("/home");
      }
    }


    return (    
          <div class="arounddev">
              <div class="login-container">
                <div className="email-header">
                   <h1>Login</h1>
                </div>


                  
                  <form class="login-form" onSubmit={login}>
                      <label class="login-label" for="username">Email</label>
                      <div  id="emailerror" name="emailerror">
                          <input onChange={changeinputtext} class="login-input" type="text" id="username" name="username" ></input>
                      </div>

                      <label class="login-label" for="password">Passwort</label>
                      <div className={aftercontentemail ? "login-after-div" : "not-aktive-login-after"}>
                          <input onChange={changeinputtext} class="login-input" autocomplete="current-password" type="password" id="password" name="password" ></input>
                      </div>

                      <div class="remember-me">
                          <a href="/forgottpw_email" class="forgot-password" >Passwort vergessen?</a>
                      </div>



                      <button class="login-button" onClick={login} >
                          {buttonText}
                      </button>
                  </form>
              </div>
          </div>


    )
}
export default Login;